import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LOGO_URL } from "../../lib/api";

export const Loader = () => {
  const [done, setDone] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setDone(true), 1500);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-[#060A17]"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
          data-testid="site-loader"
        >
          <div className="nm-grid-bg absolute inset-0 opacity-30" />
          <motion.img
            src={LOGO_URL}
            alt="Next Mile Compliance"
            className="relative w-56 sm:w-72 object-contain drop-shadow-2xl"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
          />
          <div className="relative mt-8 h-[3px] w-56 sm:w-72 overflow-hidden rounded-full bg-white/10">
            <div className="h-full nm-gold-bg" style={{ animation: "loaderFill 1.4s ease-out forwards" }} />
          </div>
          <p className="relative mt-4 font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">
            Loading your next mile
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
